<template>
  <BaseLayout :title="title">
    <template #actions>
      <InlineButton @click="onCreate" pill shadow>
        <span class="text-uppercase">{{ $t('text.newButton') }}</span>
      </InlineButton>
    </template>

    <BusinessTable
      :list="businessList"
      :current-page="currentPage"
      :meta="businessListMeta"
      :is-loading="isLoading"
      @onShowDetails="onShowDetails"
      @edit="onEdit"
      @onChangePage="onChangePage"
    />

    <BusinessAddEditModal
      :form-data="dataToEdit"
      :modal-id="editModalId"
      @onHidden="onHidden"
      @onRemove="onConfirmDelete"
    />

    <ConfirmDialog :id="deleteModalId" @ok="remove" />
  </BaseLayout>
</template>
<script>
import { mapGetters } from 'vuex';
import { BUSINESS_LIST_REQUEST, BUSINESS_DELETE } from '@/store/actions/business';
import BaseLayout from '@/components/ui/BaseLayout';
import InlineButton from '@/components/ui/button/InlineButton';
import BusinessTable from '@/components/manage/businesses/BusinessTable';
import BusinessAddEditModal from '@/components/manage/businesses/BusinessAddEditModal';
import ConfirmDialog from '@/components/ui/ConfirmDialog';

export default {
  props: {
    title: String,
  },

  data() {
    return {
      currentPage: 1,
      dataIdToEdit: null,
      dataIdToRemove: null,
      editModalId: 'manage-form-modal',
      deleteModalId: 'manage-delete-modal',
    };
  },

  computed: {
    ...mapGetters(['businessList', 'businessListMeta', 'businessListStatus', 'getBusinessById']),
    dataToEdit() {
      return this.dataIdToEdit ? this.getBusinessById(this.dataIdToEdit) : null;
    },
    isLoading() {
      return this.businessListStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      const payload = {
        limit: 10,
        page: this.currentPage,
      };

      await this.$store.dispatch(BUSINESS_LIST_REQUEST, payload);
    },
    emptyingDataToEdit() {
      this.dataIdToEdit = null;
    },
    onCreate() {
      this.emptyingDataToEdit();
      this.openModal();
    },
    onEdit(id) {
      this.dataIdToEdit = id;
      this.openModal();
    },
    openModal() {
      this.$bvModal.show(this.editModalId);
    },
    onShowDetails(id) {
      this.$emit('onShowDetails', id);
    },
    onChangePage(page) {
      this.currentPage = page;
      this.fetchData();
    },
    onConfirmDelete(id) {
      this.dataIdToRemove = id;
      this.$bvModal.show(this.deleteModalId);
    },
    async remove() {
      await this.$store.dispatch(BUSINESS_DELETE, this.dataIdToRemove);
      if (this.businessStatus === 'deleted') {
        this.emptyingDataToEdit();
        this.$bvModal.hide(this.editModalId);
        this.dataIdToRemove = null;
        this.fetchData();
      }
    },
    onHidden() {
      this.emptyingDataToEdit();
    },
  },

  components: {
    BaseLayout,
    InlineButton,
    BusinessTable,
    BusinessAddEditModal,
    ConfirmDialog,
  },
};
</script>
